// src/components/Common/RichText.js
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// Azure 建議說明本身是 HTML（<br>、<a> 等），維持原本的 HTML 顯示
const HTML_TAG_PATTERN = /<\/?(p|br|a|ul|ol|li|b|strong|em|i|code|pre|div|span|h[1-6]|table)\b[^>]*>/i;

// Markdown 單一換行不會斷行；純文字的換行改成硬換行，空白行（段落）維持不變
const preserveLineBreaks = (text) => text.replace(/([^\n])\n(?!\n)/g, '$1  \n');

const markdownComponents = {
  a: ({ node, children, ...props }) => (
    <a {...props} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
};

/**
 * 顯示雲端平台回傳的說明文字：含 HTML 標籤時照 HTML 呈現，其餘一律以 Markdown 轉換
 * （連結、粗體、行內程式碼、清單）；Markdown 路徑不執行原始 HTML。
 */
export default function RichText({ text, className }) {
  const content = String(text || '');

  if (HTML_TAG_PATTERN.test(content)) {
    return <div className={className} dangerouslySetInnerHTML={{ __html: content }} />;
  }

  return (
    <div className={className}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
        {preserveLineBreaks(content)}
      </ReactMarkdown>
    </div>
  );
}
